module.exports = __webpack_public_path__ + "static/media/head-right-side.f96cbd5e.png";